var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{staticClass:"axis-title",attrs:{"data-role":"AxisYTitle"}},[_c('text',{attrs:{"x":-(_vm.CHART_SIZE.height / 2 + _vm.CHART_SIZE.base_unit * 0.2),"y":_vm.CHART_SIZE.base_unit * 0.1}},[_vm._v("\n    % of repeat orders\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }